import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { IFleetModelInput } from "models/fleetModel";
import createFleetModelValidator from "validators/createFleetModel.validator";
import { createFleetModelApi } from "api/fleetModel";
import { uploadFleetModelApi } from "api/upload";
import { RcFile } from "antd/es/upload";

export default function useCreateFleetModel() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<IFleetModelInput>({
    resolver: yupResolver(createFleetModelValidator) as any,
    defaultValues: {
      is_shared: false,
    },
  });

  const onSubmit = async (input: IFleetModelInput) => {
    setLoading(true);

    let imageUrl = "";
    if (input.image && Array.isArray(input.image) && input.image.length > 0) {
      const file = input.image[0];
      imageUrl = file.url || file.response?.url || "";
    }

    // Convert search_radius to number or null for API
    const payload: any = {
      ...input,
      image: imageUrl,
      search_radius:
        input.search_radius && input.search_radius.trim() !== ""
          ? parseFloat(input.search_radius)
          : null,
    };

    if (!imageUrl) {
      showError("Please wait for the image to finish uploading or select a valid image.");
      setLoading(false);
      return;
    }

    const { data, error } = await createFleetModelApi(payload);
    if (data) {
      showSuccess("Fleet model created Successfully");
      navigate(RouteName.FLEET_MODEL, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  const handleUpload = async (file: RcFile) => {
    const { data, error } = await uploadFleetModelApi(file);
    if (data && data.data) {
      return data.data.url;
    } else showError(`Error while uploading image: ${error?.message}`);
  };

  return { handleSubmit, handleUpload, onSubmit, control, loading };
}
